import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import './ClientLogin.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

function EmailVerification() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('');

  useEffect(() => {
    verifyEmail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const verifyEmail = async () => {
    try {
      const response = await axios.get(`${API_URL}/auth/verify-email/${token}`);
      
      setStatus('success');
      setMessage(response.data.message || 'Email verified successfully!');
      
      // Redirect to login after 3 seconds
      setTimeout(() => {
        navigate('/client/login', { 
          state: { message: 'Email verified! You can now login.' } 
        });
      }, 3000);
      
    } catch (err) {
      setStatus('error');
      setMessage(err.response?.data?.message || 'Verification failed. The link may be expired or invalid.');
    }
  };

  return (
    <div className="client-login-page">
      <div className="login-container">
        <div className="login-card" style={{ maxWidth: '500px', margin: '0 auto', textAlign: 'center' }}>
          {status === 'verifying' && (
            <>
              <div style={{ fontSize: '4rem', marginBottom: '1.5rem' }}>⏳</div>
              <h1 style={{ marginBottom: '1rem' }}>Verifying Your Email</h1>
              <p style={{ color: '#6b7280' }}>Please wait while we verify your email address...</p>
              <div style={{ 
                marginTop: '2rem',
                padding: '1rem',
                background: '#f3f4f6',
                borderRadius: '8px'
              }}>
                <div style={{
                  width: '50px',
                  height: '50px',
                  border: '4px solid #e5e7eb',
                  borderTop: '4px solid #2563eb',
                  borderRadius: '50%',
                  margin: '0 auto',
                  animation: 'spin 1s linear infinite'
                }}></div>
              </div>
            </>
          )}

          {status === 'success' && (
            <>
              <div style={{ fontSize: '4rem', marginBottom: '1.5rem' }}>✅</div>
              <h1 style={{ marginBottom: '1rem', color: '#059669' }}>Email Verified!</h1>
              <div className="alert alert-success" style={{ textAlign: 'left' }}>
                {message}
              </div>
              <p style={{ marginTop: '1.5rem', color: '#6b7280' }}>
                Redirecting you to login in 3 seconds...
              </p>
              <Link 
                to="/client/login"
                className="btn btn-primary"
                style={{ marginTop: '1.5rem', display: 'inline-block' }}
              >
                Go to Login Now
              </Link>
            </>
          )}

          {status === 'error' && (
            <>
              <div style={{ fontSize: '4rem', marginBottom: '1.5rem' }}>❌</div>
              <h1 style={{ marginBottom: '1rem', color: '#dc2626' }}>Verification Failed</h1>
              <div className="alert alert-error" style={{ textAlign: 'left' }}>
                {message}
              </div>
              <div style={{
                background: '#f0f9ff',
                border: '1px solid #bfdbfe',
                borderRadius: '8px',
                padding: '1.5rem',
                marginTop: '1.5rem',
                textAlign: 'left'
              }}>
                <h3 style={{ fontSize: '1rem', fontWeight: 600, marginBottom: '0.75rem', color: '#1e40af' }}>
                  What to do next:
                </h3>
                <ul style={{ margin: 0, paddingLeft: '1.5rem', color: '#1e40af' }}>
                  <li style={{ marginBottom: '0.5rem' }}>The verification link may have expired</li>
                  <li style={{ marginBottom: '0.5rem' }}>Try registering again or request a new verification email</li>
                  <li>Contact support if the problem persists</li>
                </ul>
              </div>
              <Link 
                to="/client/login"
                className="btn btn-primary"
                style={{ marginTop: '1.5rem', display: 'inline-block' }}
              >
                Back to Login
              </Link>
            </>
          )}
        </div>
      </div>

      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

export default EmailVerification;
